import React from 'react';
import Bugsnag from '@bugsnag/js';
// import { text as mpvId, text, translatedUrlUtil, text as url } from '@vp/dst-localization-util';
import { Box, FlexBox, P, Spinner } from '@vp/swan';
import { __, __product, __url, __vistaRoute, getCurrentCulture } from '@99designs/i18n';
import { Price } from '@99designs/pricing';
import { useMyDesignServicesFeaturedProductsQuery } from '../../queries/FeaturedProducts.generated';
import FeaturedCard from './FeaturedCard';
import ModalSubheader from './ModalSubheader';

export default function FeaturedCards() {
    const { data, loading, error } = useMyDesignServicesFeaturedProductsQuery();
    const currentCulture = getCurrentCulture();

    if (loading) {
        return (
            <Box marginBottom={'6'}>
                <FlexBox
                    alignItems="center"
                    justifyContent="center"
                    padding="3"
                    flexDirection={'column'}
                >
                    <P>{__('Looking for featured products')}</P>
                    <Spinner accessibleText={__('Loading')} />
                </FlexBox>
            </Box>
        );
    }

    if (error || !data) {
        if (error) {
            Bugsnag.notify(
                new Error(`Failed to query MyDesignServicesFeaturedProducts: ${error.message}`)
            );
        }

        return (
            <Box marginBottom={'6'}>
                <FlexBox
                    alignItems="center"
                    justifyContent="center"
                    padding="3"
                    flexDirection={'column'}
                >
                    <P>
                        {__(
                            'We had trouble looking for featured products. Click below to see all design options'
                        )}
                    </P>
                </FlexBox>
            </Box>
        );
    }

    return (
        <Box marginBottom={'6'}>
            <ModalSubheader>{__('Featured')}</ModalSubheader>
            {[...data.myDesignServicesFeaturedProducts]
                .sort((a, b) => a.position - b.position)
                .map((product, index) => (
                    <FeaturedCard
                        key={product.mpvId}
                        destinationUrl={`/design/get-started?mpvId=${product.mpvId}&locale=${currentCulture}`}
                        destinationPageName={`${product.mpvId}:Product Page`}
                        image={product.imageUrl}
                        title={product.name}
                        position={index}
                        subtitle={
                            <Price
                                price={{
                                    currency: product.price.currency,
                                    listPrice: product.price.listPriceCents,
                                }}
                            />
                        }
                    />
                ))}
        </Box>
    );
}
